




















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import router from '@/router'
import { EmployeeTypeAdminService as _employeeTypeAdminService } from '@/admin/services/employeeTypeAdmin.service'
import { EmployeeTypeDto } from '@/models/dtos/employeeTypeDto'
import { SelectDto } from '@/models/dtos/selectDto'
import { ValidationObserver } from 'vee-validate'

@Component
export default class AdminEmployeeTypeCreateOrUpdate extends Vue {
  // Ref
  $refs!: {
    employeeTypeForm: InstanceType<typeof ValidationObserver>;
  }

  // Data
  private employeeTypeId: string | null = null
  private employeeType: EmployeeTypeDto | null = null

  // Methods
  private async initTemplate() {
    this.employeeTypeId = (this.$route.params as any)?.id || null

    this.employeeType = {
      name: '',
      internalCost: 0,
      externalCost: 0
    } as EmployeeTypeDto

    if (this.employeeTypeId) {
      this.employeeType = await _employeeTypeAdminService.get(this.employeeTypeId) || this.employeeType
    }
  }

  private async saveOrUpdate(evt: any) {
    evt.preventDefault()

    const isValid = await this.$refs.employeeTypeForm.validate()
    if (!isValid) return

    if (!this.employeeTypeId) {
      const employeeTypeId = await _employeeTypeAdminService.add(this.employeeType!)
      router.push({ name: 'AdminEmployeeTypeEdit', params: { id: employeeTypeId.toString() } })
    } else {
      _employeeTypeAdminService.edit(this.employeeType!)
    }
  }

  // Getters
  private get isLoaded(): boolean {
    return !this.employeeType
  }

  // Lifecycle
  async created() {
    this.initTemplate()
  }

  // Watchers
  @Watch('$route')
  async onRouteChange() {
    this.initTemplate()
    this.$refs.employeeTypeForm.reset()
  }
}
